import React, { Component } from "react";

class DetailWindow extends Component {
	state = {};
	render() {
		let { choise, isHide, toggleShow } = this.props;
		return (
			<div className={"detailContainer " + (isHide ? "detail--hide" : "")}>
				<div className="detailBG" onClick={() => toggleShow(true)}></div>
				<div className="detailWindow ">
					<div className="detail-leftColumn">
						<img src={choise.image_url} />
						<div className="detail-price">
							<span>Aufpreis:</span>
							<span>
								€{" "}
								{choise.surcharge.toLocaleString(undefined, {
									maximumFractionDigits: 2,
								})}
							</span>
						</div>
					</div>
					<div className="detail-rightColumn">
						<span className="detail-title">{choise.label.de}</span>
						<span className="detail-desc">
							{choise.description.de.slice(0, 200)}
						</span>
						<span>Hersteller:</span>
						<a href={choise.manufacturer.url} className="detail-firma">
							{choise.manufacturer.name}
						</a>
						<div className="detail-back" onClick={() => toggleShow(true)}>
							<span>zurück</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default DetailWindow;
